import useCustomerData from "../hooks/useCustomerData";
import useFranchiseData from "../hooks/useFranchiseData";
import useLinkOffers from "../hooks/useLinkOffers";
import useRestaurantData from "../hooks/useRestaurantData";

// Memoized by parent BackgroundManager
const BackgroundHooks = () => {
  useCustomerData();
  useRestaurantData();
  useFranchiseData();
  useLinkOffers();

  return null;
};

export default BackgroundHooks;
